import { render, staticRenderFns } from "./HostedPaymentPageEditor.vue?vue&type=template&id=619d7546&scoped=true&"
import script from "./HostedPaymentPageEditor.vue?vue&type=script&lang=ts&"
export * from "./HostedPaymentPageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./HostedPaymentPageEditor.vue?vue&type=style&index=0&id=619d7546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d7546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VIcon,VRow,VTab,VTabItem,VTabs,VTooltip})
